<template>
  <div class="news" v-if="newsList.length">
    <div class="etl-title">
      <div class="title_dian">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="txt">News</div>
      <div @click="more" class="news-title-r" v-if="enabledArticle">More</div>
    </div>
    <Swipe
      vertical
      class="notice-swipe"
      :autoplay="6000"
      :show-indicators="false"
      style="
        height: 90px;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
      "
    >
      <template v-for="(item, index) in newsList">
        <SwipeItem :key="index">
          <div class="news-msg" @click="LinkToNewsDetails({ item: item, user: userInfo })">
            <div class="news-msg-l">
              <p>{{ item.title }}</p>
              <span>{{ item.publishAt | moment("YYYY/MM/DD") }}</span>
            </div>
            <div class="news-msg-r" v-if="item.covers.length">
              <img :src="item.covers[0]" v-load="'oNews'" />
            </div>
          </div>
        </SwipeItem>
      </template>
    </Swipe>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import { Swipe, SwipeItem } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {
  // 滚动提示
  name: "news",
  components: { Swipe, SwipeItem },
  data() {
    return {
      newsList: [],
      queryArticleType: {},
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exonId: "getExhibitionId",
      exhibitionConfig: "getExhibitionConfig",
    }),
    exhibitionId() {
      return this.$route.params.id || this.exonId;
    },
    enabledArticle() {
      return this.exhibitionConfig && this.exhibitionConfig.feature && this.exhibitionConfig.feature.enabledArticle;
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      LinkToNewsDetails: "linkTo/LinkToNewsDetails",
      LinkFooter: "linkTo/LinkFooter",
      LinkToHeadLinesTab: "linkTo/LinkToHeadLinesTab",
    }),
    more() {
      let opt = {
        url: "/headlinesExinfo",
        actIndex: 1,
      };
      this.LinkToHeadLinesTab(opt);
    },
    init() {
      let query = gql`
        query queryArticleType($query: QueryInput!) {
          queryArticleType(query: $query) {
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items {
              covers
              createAt
              title
              externalUrl
              id
              publishAt
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "itemId",
          v: this.exhibitionId,
        },
        EqualB: {
          n: "topic",
          v: 2,
        },
        equal_isDeleted: {
          n: "isDeleted",
          v: false,
        },
        or:{
          equal_authorType: {
            n: "authorType",
            v: 'exhibition',
          },
          equal_authorType1: {
            n: "authorType",
            v: 'exhibitor',
          },
        }
      };
      let order = [
        {
          N: "toppingIndex",
          v: 0,
        },
        {
          N: "publishAt",
          v: 0,
        },
      ];
      let opt = {
        page: 1,
        size: 5,
        where: JSON.stringify(where),
        order: JSON.stringify(order),
      };
      this.$apollo.addSmartQuery("queryArticleType", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          let res = JSON.parse(JSON.stringify(data.data.queryArticleType));
          if (res && res.items.length) {
            res.items.forEach((e) => {
              if (e.covers && e.covers.indexOf("[") != -1) {
                e.covers = JSON.parse(e.covers);
              } else {
                e.covers = [];
              }
              e.publishAt = moment(e.publishAt).format("YYYY/MM/DD HH:mm:ss");
            });
          }
          this.newsList = res.items;
        },
        error(err) {
          console.log("err", err);
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.news {
  .etl-title {
    padding: 0.15rem 0.3rem;
    padding-top: 0;
    padding-left: 0;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #333;
    .title_dian {
      display: flex;
      justify-content: space-between;
      width: 0.06rem;
      height: 0.24rem;
      flex-direction: column;
      margin-right: 0.1rem;
      position: relative;
      span {
        width: 0.06rem;
        height: 0.06rem;
        display: block;
        border-radius: 0.02rem;
        background-image: linear-gradient(90deg, #ff4b1b 0%, #fe781d 100%), linear-gradient(#108ee9, #108ee9);
        &:nth-child(1) {
          opacity: 0.5;
        }
        &:nth-child(2) {
          opacity: 0.75;
        }
      }
    }
    img {
      width: 13px;
    }
    .txt {
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  background: #fff;
  margin-bottom: 15px;
  padding: 15px;
  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
    &-l {
      width: 66px;
      height: 15px;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    &-r {
      font-size: 0.22rem;
      color: #666;
      font-family: "PingFang-SC-Bold";
      position: absolute;
      right: 0.3rem;
    }
  }
  &-msg {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0.2rem;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    &-l {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: calc(100% - 140px);
      p {
        font-size: 0.28rem;
        line-height: 1.6;
        color: #222;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      span {
        font-size: 0.22rem;
        line-height: 1.2;
        color: #8a8a8a;
      }
    }
    &-r {
      width: 105px;
      height: 68px;
      border-radius: 3px;
      img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 3px;
      }
    }
  }
  &-msg-2 {
    p {
      font-size: 15x;
      line-height: 1.6;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      padding-bottom: 10px;
    }
    span {
      font-size: 12px;
      line-height: 1.2;
      color: #8a8a8a;
    }
  }
}
.notice-swipe {
  height: 170px;
}
</style>
